import { HTTP } from "@/common/http-common";

const RESOURCE_NAME = "entities/companys";

export default {
  async getAll(options = {}) {
    const response = await HTTP.get(`${RESOURCE_NAME}`, options);
    return response.data;
  },

  async get(id) {
    return (await HTTP.get(`${RESOURCE_NAME}/${id}`)).data;
  },

  async getByUser() {
    return (await HTTP.get(`${RESOURCE_NAME}/getByUser`)).data;
  },

  async deactivate(id) {
    return await HTTP.put(`${RESOURCE_NAME}/${id}/deactivate`);
  },

  async save(entity) {
    if (entity.id) {
      return (await HTTP.put(`${RESOURCE_NAME}/${entity.id}`, entity)).data;
    } else {
      return (await HTTP.post(`${RESOURCE_NAME}`, entity)).data;
    }
  },
};
